// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

import { API_BASE_URL } from '@/config/api'

/** Build `wss://` / `ws://` URL for notification WebSocket (token in query). */
export function notificationsWebSocketUrl(token: string): string {
  const base = API_BASE_URL.replace(/\/$/, '')
  const wsBase = base.startsWith('https://')
    ? `wss://${base.slice('https://'.length)}`
    : `ws://${base.slice('http://'.length)}`
  return `${wsBase}/v1/account/notifications/ws?token=${encodeURIComponent(token)}`
}
